import { render, staticRenderFns } from "./mergedList.vue?vue&type=template&id=4912e228"
import script from "./mergedList.vue?vue&type=script&lang=js"
export * from "./mergedList.vue?vue&type=script&lang=js"
import style0 from "./mergedList.vue?vue&type=style&index=0&id=4912e228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports